import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Reveal, PageHero, SectionHeading, CTABand, ICONS } from "@/components/Common";
import { SERVICES } from "@/data/site";

const Services = () => (
  <>
    <PageHero
      crumb="Home — Services"
      title="Our Services"
      subtitle="Six focused service verticals covering manpower, security, facility, sanitation, warehousing and event requirements."
    />
    <section className="py-16 sm:py-20 lg:py-24 bg-[#FAFAFC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Service Verticals"
          title="Structured Workforce Solutions"
          desc="Every service is delivered with supervised deployment, managed attendance and compliance-first administration."
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.slug} delay={(i % 2) * 0.1}>
                <Link
                  to={s.path}
                  data-testid={`services-page-card-${s.slug}`}
                  className="group grid sm:grid-cols-5 bg-white border border-slate-200 overflow-hidden h-full transition-all hover:border-gold hover:shadow-xl hover:shadow-navy/5"
                >
                  <div className="sm:col-span-2 h-48 sm:h-full overflow-hidden">
                    <img src={s.image} alt={s.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  </div>
                  <div className="sm:col-span-3 p-7">
                    <div className="flex items-center gap-3">
                      <span className="w-9 h-9 bg-navy flex items-center justify-center shrink-0 transition-colors group-hover:bg-gold">
                        <Icon size={17} className="text-gold transition-colors group-hover:text-navy" />
                      </span>
                      <h3 className="font-heading text-lg font-semibold text-navy">{s.title}</h3>
                    </div>
                    <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.short}</p>
                    <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-bold tracking-widest uppercase text-gold-hover">
                      Learn More <ChevronRight size={14} className="transition-transform group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
    <CTABand />
  </>
);

export default Services;
